import {Suspense} from 'react';
import {Container} from '@mui/material';
import {Outlet} from 'react-router-dom';
import {Loader} from 'shared/ui/loader';
import {AuthLeftBar} from 'widgets/auth-left-bar';
import {AuthRightBar} from 'widgets/auth-right-bar';
import styles from './auth-layout.module.scss';



export const AuthLayout = () => (
  <Container className={styles.authContainer} maxWidth={false} sx={
    {
      minHeight: '100vh',
      '&': {
        padding: 0,
      }
    }
  }>
    <AuthLeftBar>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </AuthLeftBar>
    <AuthRightBar />
  </Container>
);
